<template lang="pug">
  #IrAOVRechazada
    b-button(
      variant="action"
      @click="goToRejectedOV()"
    )
      | Revisar OV Rechazada
</template>
<script>

export default {
  name: 'IrAOVRechazada',
  props: {
    dataOv: { type: Object, required: true },  
  },
  methods: {
    goToRejectedOV() {
      window.open((`/oportunidad-venta/${this.dataOv.ov_rechazada}`), '_blank');
    },
  },
}
</script>
